import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/sps/Navbar";
import { Hero } from "@/components/sps/Hero";
import { About } from "@/components/sps/About";
import { Services } from "@/components/sps/Services";
import { Statement } from "@/components/sps/Statement";
import { Footer } from "@/components/sps/Footer";
import ContactoPage from "@/pages/ContactoPage";
import NosotrosPage from "@/pages/NosotrosPage";
import ServiciosPage from "@/pages/ServiciosPage";

const Landing = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.slice(1);
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 100);
    } else {
      window.scrollTo({ top: 0 });
    }
  }, [location]);

  return (
    <div className="App grain min-h-screen bg-[#001825] text-[#f8f9fa] relative">
      <Navbar />
      <main className="relative z-[2]">
        <Hero />
        <About />
        <Services />
        <Statement />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/nosotros" element={<NosotrosPage />} />
          <Route path="/servicios" element={<ServiciosPage />} />
          <Route path="/contacto" element={<ContactoPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </>
  );
}

export default App;
